import React from "react";
import ReactDOM from "react-dom";

import List from "./List";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode>
    <List />
  </React.StrictMode>,
  rootElement
);
